import React from "react";

const CakeDetailsStep = ({ formData, onChange, formOptions }) => (
  <div>
    <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-2">
      Détails du gâteau
    </h3>
    <p className="text-gray-500 text-sm mb-8">Choisissez le type de création souhaitée</p>
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Type de gâteau <span className="text-[#E5007D]">*</span>
        </label>
        <select
          name="cakeType"
          value={formData.cakeType}
          onChange={onChange}
          required
          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm appearance-none"
        >
          <option value="">Sélectionnez un type</option>
          {formOptions.cakeTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Parfum souhaité
          </label>
          <select
            name="flavor"
            value={formData.flavor}
            onChange={onChange}
            className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm appearance-none"
          >
            <option value="">Sélectionnez un parfum</option>
            {formOptions.flavors.map((flavor) => (
              <option key={flavor} value={flavor}>{flavor}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Nombre de parts
          </label>
          <select
            name="servings"
            value={formData.servings}
            onChange={onChange}
            className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm appearance-none"
          >
            <option value="">Sélectionnez le nombre</option>
            {formOptions.servings.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Budget approximatif
        </label>
        <input
          type="text"
          name="budget"
          value={formData.budget}
          onChange={onChange}
          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm"
          placeholder="ex: 80€"
        />
      </div>
    </div>
  </div>
);

export default CakeDetailsStep;
